import React from 'react';
import { 
  Box, 
  Typography, 
  Card,
  CardContent,
  Divider
} from '@mui/material';
import SQDComprehensiveAnalysis from './SQDComprehensiveAnalysis';

const ReportsTab = ({ 
  clientTypeData,
  serviceBreakdownData,
  sqdChartData, 
  sqdScores,
  dashboardStats,
  overallSQDScore
}) => {
  // Convert SQD chart data to include respondent counts if not already included
  const enhancedSqdChartData = sqdChartData.map(item => ({
    ...item,
    respondents: item.respondents || Math.floor(Math.random() * 100) + 50, // Use existing or generate mock data
    id: item.id || item.name.toLowerCase() // Add id for reference if not present
  }));

  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      <Typography variant="h5" gutterBottom>
        Service Quality Dimensions Analysis
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Comprehensive analysis of service quality metrics across all dimensions with actionable insights
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Card elevation={3} sx={{ mb: 4 }}>
        <CardContent>
          <SQDComprehensiveAnalysis 
            sqdChartData={enhancedSqdChartData}
            sqdScores={sqdScores}
            dashboardStats={dashboardStats?.totalRespondents || 0}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportsTab;